import { Button as e, Drawer as t, Modal as n, breakpointQueries as r, useMediaQuery as i } from "@systemeio/components";
import { twMerge as a } from "tailwind-merge";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { XCloseIcon as c } from "@systemeio/icons";
//#region src/components/modal/index.tsx
function l({ afterLeave: l, children: u, className: d, contentClassName: f, footer: p, isFetching: m = !1, opened: h, onClose: g, size: _, title: v }) {
	let y = i(r.isMobile, { initializeWithValue: !1 }), b = (e, t) => {
		if (!e) {
			if (m) {
				t.cancel();
				return;
			}
			g();
		}
	};
	return y ? /* @__PURE__ */ o(t.Root, {
		open: h,
		onOpenChange: b,
		onOpenChangeComplete: (e) => {
			e || l?.();
		},
		children: /* @__PURE__ */ s(t.Popup, {
			backdropProps: { forceRender: !0 },
			className: d,
			children: [
				/* @__PURE__ */ s(t.Header, {
					className: "flex-row items-center justify-between gap-2.5",
					children: [/* @__PURE__ */ o(t.Title, { children: v }), /* @__PURE__ */ o(t.Close, {
						"aria-label": "Close",
						render: /* @__PURE__ */ o(e, {
							disabled: m,
							size: "icon-sm",
							variant: "ghost-gray"
						}),
						children: /* @__PURE__ */ o(c, {})
					})]
				}),
				/* @__PURE__ */ o(t.Content, {
					className: f,
					children: u
				}),
				p && /* @__PURE__ */ o(t.Footer, { children: p })
			]
		})
	}) : /* @__PURE__ */ o(n.Root, {
		open: h,
		onOpenChange: b,
		onOpenChangeComplete: (e) => {
			e || l?.();
		},
		children: /* @__PURE__ */ s(n.Popup, {
			backdropProps: { forceRender: !0 },
			className: d,
			size: _,
			closeProps: { disabled: m },
			children: [
				/* @__PURE__ */ o(n.Header, {
					className: "flex shrink-0 items-center gap-2.5",
					children: /* @__PURE__ */ o(n.Title, { children: v })
				}),
				/* @__PURE__ */ o("div", {
					className: a("flex min-h-0 flex-1 flex-col overflow-y-auto px-8 py-6", f),
					children: u
				}),
				p && /* @__PURE__ */ o(n.Footer, {
					className: "pt-5",
					children: p
				})
			]
		})
	});
}
//#endregion
export { l as Modal };
